import { getDiamGroupId } from '~/domain/uptime/utils/utils';

const useUptime = () => {
  return {
    isUptime: getDiamGroupId() !== undefined,
  };
};
export { useUptime };
